import { render, staticRenderFns } from "./AddDependentsModal.vue?vue&type=template&id=5756a177&scoped=true&v-if=widgetReady&"
import script from "./AddDependentsModal.vue?vue&type=script&lang=js&"
export * from "./AddDependentsModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDependentsModal.vue?vue&type=style&index=0&id=5756a177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5756a177",
  null
  
)

component.options.__file = "AddDependentsModal.vue"
export default component.exports